import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { AppName } from "../../../../util/app";
import DatePicker from "react-datepicker";

const NewStaffLeave = ({ onCancel, onSubmit }) => {
    const [model, setModel] = useState({ startDate: new Date(), endDate: new Date() });
    const title = "New Annual Leave";

    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>
            <form
                onSubmit={(event) => {
                    event.preventDefault();
                    onSubmit(model);
                }}
            >
                <div className="row">
                    <div className="col-4 bg-primary pl-4">
                        <h5>{title} </h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                    <strong>Leave Date*</strong>
                                </td>
                                <td>
                                    <DatePicker
                                        selected={model.startDate}
                                        onChange={(date) => setModel({ ...model, startDate: date, endDate: date })}
                                        className="form-control input-height"
                                        dateFormat="MMMM d, yyyy"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                    <strong>Return Date*</strong>
                                </td>
                                <td>
                                    <DatePicker
                                        selected={model.endDate}
                                        onChange={(date) => setModel({ ...model, endDate: date })}
                                        className="form-control input-height"
                                        dateFormat="MMMM d, yyyy"
                                        minDate={model.startDate}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                    <strong>Note (If any)</strong>
                                </td>
                                <td>
                                    <textarea
                                        name="note-id"
                                        id="note-id"
                                        onChange={({ currentTarget }) => setModel({ ...model, note: currentTarget.value })}
                                        className="form-control form-control-textarea"
                                        rows="6"
                                        placeholder="enter note"
                                    ></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="col-12 text-center">
                        <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                            Submit <i className="material-icons">arrow_right_alt</i>
                        </button>
                        <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default">
                            <i className="material-icons text-danger">cancel</i> Cancel
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default NewStaffLeave;
